import { MenuItem, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React from "react";
import { defineMessages, useIntl } from "react-intl";

import MyTypography from "../MyTypography";
const messages = defineMessages({
  noOfRows: {
    defaultMessage: "จำนวนแถว",
    description: "pagination"
  },
  noOfRowsAdmin: {
    defaultMessage: "Rows per page:",
    description: "pagination"
  }
});
const useStyles = makeStyles(
  theme => ({
    select: {
      "& div": {
        color: "#007E92 !important",
        "&:focus": {
          background: "none"
        },
        marginLeft: theme.spacing(1)
      },
      "& svg": {
        color: theme.palette.grey[900],
        width: "2rem"
      },
      "& .MuiSelect-selectMenu": {
        color: theme.palette.info.dark,
        marginRight: "6px",
        paddingRight: "2rem"
      },
      "&:after, &:before, &:hover": {
        border: "none !important"
      }
    },
    rowPerpage: {
      display: "flex",
      alignItems: "center"
    },
    menuItems: {
      "& .MuiListItem-root": {
        fontSize: "14px",
        color: theme.palette.grey[700],
        fontFamily: "ScgFont, sans-serif",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#EBF0FA",
          borderRadius: "4px"
        }
      }
    },
    rowPerPage: {
      fontSize: 12
    }
  }),
  {
    name: "RowNumberSelect"
  }
);

interface RowNumberSelectProps {
  choices: number[];
  className?: string;
  titleRow?: string;
  rowNumber: number;
  noOfRowsThai?: boolean;
  selectColor?: string;
  onChange(value: number);
}

const RowNumberSelect: React.FC<RowNumberSelectProps> = ({
  className,
  choices,
  rowNumber,
  noOfRowsThai,
  selectColor = "#222222",
  onChange
}) => {
  const classes = useStyles({});
  const intl = useIntl();
  return (
    <div className={classNames(classes.rowPerpage, className)}>
      <MyTypography variant="body3" className={classes.rowPerPage}>
        {intl.formatMessage(
          !noOfRowsThai ? messages.noOfRowsAdmin : messages.noOfRows
        )}
      </MyTypography>
      <Select
        data-testid="row-number-select"
        className={classes.select}
        value={rowNumber}
        IconComponent={props => <KeyboardArrowDownIcon {...props} />}
        onChange={event => onChange(event.target.value as number)}
        MenuProps={{
          className: classes.menuItems
        }}
        SelectDisplayProps={{
          style: {
            color: selectColor
          }
        }}
      >
        {choices.length > 0 &&
          choices.map(choice => (
            <MenuItem
              value={choice}
              key={choice}
              data-testid="row-number-option"
            >
              {choice}
            </MenuItem>
          ))}
      </Select>
    </div>
  );
};

export default RowNumberSelect;
